import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './ResetPasswordPage.css';

const ResetPasswordPage = () => {
    const navigate = useNavigate();
    const { uid, token } = useParams();


    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (password !== confirmPassword) {
            setError("Les mots de passe ne correspondent pas.");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(`${API_URL}/dj-rest-auth/password/reset/confirm/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    uid: uid,
                    token: token,
                    new_password1: password,
                    new_password2: confirmPassword,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage('Votre mot de passe a été réinitialisé avec succès.');
                // Optionally redirect to login after a delay
                setTimeout(() => {
                    navigate('/connexion');
                }, 3000);
            } else {
                if (data.detail) {
                    setError(data.detail);
                } else if (data.new_password1) {
                    setError(data.new_password1[0]);
                } else {
                    setError('Erreur lors de la réinitialisation.');
                }
            }
        } catch (err) {
            console.error("Reset Confirm Error:", err);
            setError('Impossible de contacter le serveur.');
        } finally {
            setLoading(false);
        }
    };

    if (!uid || !token) {
        return (
            <div className="reset-password-container">
                <div className="reset-password-card">
                    <p className="error-message">Lien invalide ou expiré.</p>
                    <button onClick={() => navigate('/connexion')} className="back-link">Retour à la connexion</button>
                </div>
            </div>
        );
    }

    return (
        <div className="reset-password-container">
            <div className="reset-password-card">
                <h1 className="reset-password-title">Nouveau mot de passe</h1>

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="password">Nouveau mot de passe</label>
                        <input
                            type="password"
                            id="password"
                            className="input-field"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            minLength={8}
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="confirmPassword">Confirmer le mot de passe</label>
                        <input
                            type="password"
                            id="confirmPassword"
                            className="input-field"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                        />
                    </div>

                    {message && <div className="success-message">{message}</div>}
                    {error && <div className="error-message">{error}</div>}

                    <button type="submit" className="reset-btn" disabled={loading}>
                        {loading ? 'Réinitialisation...' : 'Réinitialiser le mot de passe'}
                    </button>
                </form>
                <button onClick={() => navigate('/connexion')} className="back-link" style={{ background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline' }}>
                    Annuler
                </button>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
